import { render, staticRenderFns } from "./OnboardingHome.vue?vue&type=template&id=f476e558&"
import script from "./OnboardingHome.vue?vue&type=script&lang=js&"
export * from "./OnboardingHome.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingHome.vue?vue&type=style&index=0&id=f476e558&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f476e558')) {
      api.createRecord('f476e558', component.options)
    } else {
      api.reload('f476e558', component.options)
    }
    module.hot.accept("./OnboardingHome.vue?vue&type=template&id=f476e558&", function () {
      api.rerender('f476e558', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OnboardingHome.vue"
export default component.exports